import { createApp } from "vue";
import "./registerServiceWorker";
import { router, setStore } from "search-observe-app"; //named export syntax
import store from "./store";
import { vuetify } from "search-observe-app";
import Cookies from "vue-cookies";
// eslint-disable-next-line
import styles from "./styles/source_sans_pro.css";
import { App } from "search-observe-app";
import { setPluginStore } from "search-observe-app";

setStore(store);
setPluginStore(store);
const app = createApp(App);
app.use(Cookies);
//app.use(Datetime);
app.use(router);
app.use(store);
app.use(vuetify);
app.config.productionTip = false;
app.mount("#app");
